var _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1044,
    cy: 18,
    r: 18,
    fill: "#5196FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2935_15152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 36
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1044,
    cy: 18,
    r: 18,
    fill: "#5196FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2935_15152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2935_15152",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3077 28.3447L28.4056 8.29853L8.35941 11.3965L12.4943 15.5314L1.19155 26.8341L9.87059 35.5132L21.1734 24.2104L25.3077 28.3447Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3077 28.3447L28.4056 8.29853L8.35941 11.3965L12.4943 15.5314L1.19155 26.8341L9.87059 35.5132L21.1734 24.2104L25.3077 28.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4056 8.29853L29.3939 8.45126L29.6024 7.1017L28.2529 7.31026L28.4056 8.29853ZM25.3077 28.3447L24.6006 29.0518L25.9948 30.4461L26.2959 28.4975L25.3077 28.3447ZM8.35941 11.3965L8.20668 10.4082L6.25806 10.7093L7.6523 12.1036L8.35941 11.3965ZM12.4943 15.5314L13.2014 16.2385L13.9085 15.5314L13.2014 14.8242L12.4943 15.5314ZM1.19155 26.8341L0.484439 26.127L-0.222668 26.8341L0.484439 27.5412L1.19155 26.8341ZM9.87059 35.5132L9.16349 36.2203L9.87059 36.9274L10.5777 36.2203L9.87059 35.5132ZM21.1734 24.2104L21.8805 23.5033L21.1734 22.7962L20.4663 23.5033L21.1734 24.2104ZM27.4173 8.1458L24.3194 28.192L26.2959 28.4975L29.3939 8.45126L27.4173 8.1458ZM8.51213 12.3847L28.5583 9.2868L28.2529 7.31026L8.20668 10.4082L8.51213 12.3847ZM13.2014 14.8242L9.06652 10.6893L7.6523 12.1036L11.7872 16.2385L13.2014 14.8242ZM1.89865 27.5412L13.2014 16.2385L11.7872 14.8242L0.484439 26.127L1.89865 27.5412ZM10.5777 34.8061L1.89865 26.127L0.484439 27.5412L9.16349 36.2203L10.5777 34.8061ZM20.4663 23.5033L9.16349 34.8061L10.5777 36.2203L21.8805 24.9175L20.4663 23.5033ZM26.0148 27.6376L21.8805 23.5033L20.4663 24.9175L24.6006 29.0518L26.0148 27.6376Z",
    fill: "white",
    mask: "url(#path-3-inside-1_2935_15152)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBurger);
export default __webpack_public_path__ + "static/media/custom-burger.5457bca1ad67bf70b12e2814032b88ad.svg";
export { ForwardRef as ReactComponent };